import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { Typography } from 'antd'
import { blogData } from './BlogLst'
import dayjs from 'dayjs'
import {
	GeneralContentWrapper,
	GeneralTitle
} from '../../../components/Shared/GeneralComponents'

const { Paragraph } = Typography

const BlogItm = () => {
	const { page } = useParams()

	const [pageContent, setPageContent] = useState({})

	//TODO: Replace with Real API call (Simulate API call to get  data)
	const getPageContent = (page) => {
		const content = blogData.find((item) => item.link === page)
		return content || {}
	}

	useEffect(() => {
		setPageContent(getPageContent(page))
	}, [page])

	return (
		<GeneralContentWrapper>
			<GeneralTitle text={pageContent?.title} />
			<Typography>
				<Paragraph>Categories: {pageContent?.category}</Paragraph>
				<Paragraph>
					Post Date:{' '}
					{dayjs?.unix(pageContent.createdTs)?.format('MMMM D, YYYY')}
				</Paragraph>
			</Typography>
		</GeneralContentWrapper>
	)
}

export default BlogItm
